module.exports = "/next-static/_next/static/images/block_image_two_2x-094d970393e88261c44581cca7744926.webp";